<template>
 <form method="post" @submit.prevent="submit" @keydown="clearErrors($event.target.name)">
  <div class="alert alert-success text-center" v-show="form.succeeded" id="result"> {{ trans('adminlte_lang_message.registered') }} <i class="fa fa-refresh fa-spin"></i> {{ trans('adminlte_lang_message.entering') }}</div>

  <div class="form-group has-feedback" :class="{ 'has-error': form.errors.has('phone') }">
   <input type="tel" class="form-control" :placeholder="trans('adminlte_lang_message.phone')" name="phone" value="" v-model="form.phone" required autofocus/>
   <span class="glyphicon glyphicon-phone form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
   </transition>
  </div>

  <div class="form-group">
   <button type="button" class="btn btn-info btn-block btn-flat" id="js_btnSendCode" @click="sendCode"><i v-if="verify" class="fa fa-refresh fa-spin"></i> 发送验证码</button>
  </div>

  <div class="form-group has-feedback" :class="{ 'has-error': form.errors.has('code') }">
   <input type="number" step="1" max="99999" class="form-control" :placeholder="trans('adminlte_lang_message.code')" name="code" value="" v-model="form.code" required readonly/>
   <span class="glyphicon glyphicon-send form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('code')" v-text="form.errors.get('code')"></span>
   </transition>
  </div>

  <!-- <div class="form-group has-feedback " :class="{ 'has-error': form.errors.has('name') }">
   <input type="text" class="form-control" :placeholder="trans('adminlte_lang_message.fullname')" name="name" value="" v-model="form.name" required readonly/>
   <span class="glyphicon glyphicon-user form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
   </transition>
  </div>

  <div class="form-group has-feedback" :class="{ 'has-error': form.errors.has('qq') }">
   <input type="number" class="form-control" placeholder="QQ" name="qq" value="" v-model="form.qq" readonly/>
   <span class="glyphicon glyphicon-comment form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('qq')" v-text="form.errors.get('qq')"></span>
   </transition>
  </div>

  <div class="form-group has-feedback" :class="{ 'has-error': form.errors.has('email') }">
   <input type="email" class="form-control" :placeholder="trans('adminlte_lang_message.email')" name="email" value="" v-model="form.email" readonly/>
   <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
   </transition>
  </div>

  <div class="form-group has-feedback" :class="{ 'has-error': form.errors.has('aff') }">
   <input type="text" class="form-control" :placeholder="trans('adminlte_lang_message.aff')" name="aff" value="" v-model="form.aff" readonly/>
   <span class="glyphicon glyphicon-user form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('aff')" v-text="form.errors.get('aff')"></span>
   </transition>
  </div>

  <div class="form-group has-feedback" :class="{ 'has-error': form.errors.has('password') }">
   <input type="password" class="form-control" :placeholder="trans('adminlte_lang_message.password')" name="password" v-model="form.password" required readonly/>
   <span class="glyphicon glyphicon-lock form-control-feedback"></span>
   <transition name="fade">
    <span class="help-block" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
   </transition>
  </div>

  <div class="form-group has-feedback">
   <input type="password" class="form-control" :placeholder="trans('adminlte_lang_message.retypepassword')" name="password_confirmation" v-model="form.password_confirmation" required readonly/>
  </div> -->

  <div class="row">
   <div class="col-xs-7">
    <label>
     <div class="checkbox_register icheck">
      <label data-toggle="modal" data-target="#termsModal">
       <input type="checkbox" name="terms" v-model="form.terms" class="has-error" checked>
       <a href="#" :class="{ 'text-danger': form.errors.has('terms') }" v-text="trans('adminlte_lang_message.conditions')"></a>
      </label>
     </div>
    </label>
   </div>

   <div class="col-xs-4 col-xs-push-1">
    <button type="submit" class="btn btn-primary btn-block btn-flat" :disabled="form.errors.any()" v-text="trans('adminlte_lang_message.register')" disabled="disabled"><i v-if="form.submitting" class="fa fa-refresh fa-spin"></i> </button>
   </div>
  </div>

  <div v-if="form.errors.has('terms')" class="form-group has-feedback" :class="{ 'has-error': form.errors.has('terms') }">
   <span class="help-block" v-if="form.errors.has('terms')" v-text="form.errors.get('terms')"></span>
  </div>
 </form>
</template>

<style src="./fade.css"></style>

<script>

  import Form from 'acacha-forms'
  import initialitzeIcheck from './InitializeIcheck'
  import redirect from './redirect'

  export default {
    mixins: [initialitzeIcheck, redirect],
    data: function () {
      return {
        form: new Form({
          phone: '',
          code: '',
          terms: ''
        }),
        verify: false
      }
    },
    watch: {
      'form.terms': function (value) {
        if (value) {
          $('input').iCheck('check')
        } else {
          $('input').iCheck('uncheck')
        }
      }
    },
    methods: {
      sendCode () {
        this.verify = true;
        (new Form({ mobile: this.form.phone })).post('/sms/verify-code')
          .then(res => {
            if (res.data.success == true) {
              $('input').attr('readonly', false)
              $('button').attr('disabled', false)
              $('#js_btnSendCode').text(res.data.message).attr('disabled', true)
              setTimeout(function(){
                $('#js_btnSendCode').text('重新发送').attr('disabled', false)
              }, 60000)
              this.verify = false
            } else {
              $('#js_btnSendCode').text(res.data.message).attr('disabled', true)
              setTimeout(function(){
                $('#js_btnSendCode').text('发送验证码').attr('disabled', false)
              }, 60000)
              this.verify = false
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      submit () {
        this.form.post('/register')
          .then(response => {
            var component = this;
            setTimeout(function(){
              component.redirect(response)
            }, 500);
          })
          .catch(error => {
            console.log(this.trans('adminlte_lang_message.registererror') + ':' + error)
          })
      },
      clearErrors (name) {
        if (name === 'password_confirmation') {
          name = 'password'
          this.form.errors.clear('password_confirmation')
        }
        this.form.errors.clear(name)
      }
    },
    mounted () {
      this.initialitzeICheck('terms')

      let aff = document.head.querySelector('meta[name="aff"]')
      if (aff) this.form.aff = aff.content
    }
  }

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/RegisterForm.vue